import { render, staticRenderFns } from "./transactionsTable.vue?vue&type=template&id=32298c22&"
import script from "./transactionsTable.vue?vue&type=script&lang=js&"
export * from "./transactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports